function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWithNameVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Artwork",
    width: 100,
    height: 180,
    viewBox: "0 0 100 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.736618,
    y: 152.79021,
    width: 4.7835746,
    height: 18.130487,
    id: "rect6",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 32.092929,144.80803 a 2.739725,2.739725 0 1 0 2.807652,2.73821 2.7080257,2.7080257 0 0 0 -2.807652,-2.73821 z",
    id: "path8",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.81,143.37 66.434,143.37 70.728,155.381 74.403,155.381 78.698,143.37 75.322,143.37 72.566,152.005 ",
    id: "polygon10",
    style: {
      fill: "#fc686e"
    },
    transform: "matrix(1.5094903,0,0,1.5094903,-62.665327,-63.625421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 66.045895,152.33888 c -5.163966,0 -8.874294,4.09071 -8.874294,9.56866 a 9.0433566,9.0433566 0 0 0 9.533941,9.46299 8.6040949,8.6040949 0 0 0 7.627455,-3.98656 l -3.156344,-2.39255 a 5.2832162,5.2832162 0 0 1 -4.401674,2.21895 4.4031833,4.4031833 0 0 1 -4.715648,-4.15864 h 12.759722 c 0.03321,-0.34718 0.03321,-0.69437 0.03321,-1.04155 -0.003,-5.92777 -3.189554,-9.6713 -8.806368,-9.6713 z m -3.846181,7.59122 a 3.8416529,3.8416529 0 0 1 3.915618,-3.6741 3.7027798,3.7027798 0 0 1 3.883918,3.6741 z",
    id: "path12",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 26.051949,161.83206 a 9.5611118,9.5611118 0 1 0 -4.635645,8.18597 5.0009415,5.0009415 0 0 1 -8.758063,2.28989 l -3.49447,2.9103 a 9.5520548,9.5520548 0 0 0 16.895725,-6.10891 h -3.381258 a 9.530922,9.530922 0 0 0 3.373711,-7.27725 z m -9.552055,5.00396 a 5.0039605,5.0039605 0 1 1 5.002451,-5.00396 5.0099984,5.0099984 0 0 1 -5.002451,5.00396 z",
    id: "path14",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 86.279103,152.28755 a 9.5520548,9.5520548 0 1 0 9.552055,9.55206 9.5641307,9.5641307 0 0 0 -9.552055,-9.55206 z m 0,14.55602 a 5.0039605,5.0039605 0 1 1 5.003961,-5.00396 5.0099984,5.0099984 0 0 1 -5.003961,5.00396 z",
    id: "path16",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 94.412237,46.600582 A 44.611477,44.611477 0 1 0 72.779731,84.801254 23.33823,23.33823 0 0 1 31.880091,95.47486 L 15.568539,109.06028 A 44.576759,44.576759 0 0 0 94.412237,80.552038 H 78.671272 A 44.48468,44.48468 0 0 0 94.412237,46.600582 Z M 49.836988,69.949378 A 23.348796,23.348796 0 1 1 73.188803,46.600582 23.375967,23.375967 0 0 1 49.836988,69.949378 Z",
    id: "path18",
    style: {
      fill: "#fc686e",
      strokeWidth: 1.50949037
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithNameVertical);
export default __webpack_public_path__ + "static/media/logo-with-name-vertical.8de9cc039594b330d229a6b8863f99a9.svg";
export { ForwardRef as ReactComponent };